import { Mark, mergeAttributes } from '@tiptap/core'

export const InsertionMark = Mark.create({
  name: 'insertion',

  parseHTML() {
    return [
      { tag: 'ins' },
      { tag: 'span[data-diff="insert"]' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['ins', mergeAttributes(HTMLAttributes, { class: 'diff-insert' }), 0]
  },
})

export const DeletionMark = Mark.create({
  name: 'deletion',

  parseHTML() {
    return [
      { tag: 'del' },
      { tag: 's[data-diff="delete"]' },
      { tag: 'span[data-diff="delete"]' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['del', mergeAttributes(HTMLAttributes, { class: 'diff-delete' }), 0]
  },
})

export const diffMarks = [InsertionMark, DeletionMark]
